// extracted by css-extract-rspack-plugin
export default {"outdated":"outdated--mP5XwSjLVyU38ZHq","text":"text--zQ7E6vdW6p8Yx0PU"};